import formatDate from "../formatDate";

const TransactionDescription = ({
  fundingSource,
  serviceId,
  employer,
  isRollover,
  hraId,
  id,
  effectiveDate,
}) => {
  let displayValue = "";
  let fundingSourceString = "";
  if (typeof fundingSource === "string") fundingSourceString = fundingSource;

  if (Boolean(hraId)) {
    //@ts-ignore
    displayValue = formatDate({
      data: effectiveDate,
      actions: ["display"],
      options: ["append-timezone"],
    });
  } else if (isRollover) {
    displayValue = `Rollover ${
      fundingSource?.nickname ? `(${fundingSource?.nickname})` : ""
    }`;
  } else if (serviceId === "payroll") {
    displayValue = "Payroll";
  } else if (employer?.name) {
    displayValue = `Employer (${employer.name})`;
  } else if (fundingSourceString === "deleted") {
    displayValue = "Bank Account";
  } else if (fundingSource?.id === "payroll") {
    displayValue = "Company Payroll";
  } else if (!Boolean(fundingSource?.nickname)) displayValue = "ACH";
  else if (Boolean(fundingSource?.nickname)) {
    displayValue = `ACH (${fundingSource?.nickname})`;
  }
  return displayValue;
};

export default TransactionDescription;
